import { useQuery } from '@tanstack/react-query';

import { Icon, listIcons } from '~/services/AccommodationService';

export const accommodationIconQueryKeys = {
  all: ['accommodation', 'icons'] as const,
};

export function useListIcons() {
  return useQuery({
    queryKey: accommodationIconQueryKeys.all,
    queryFn: async () => {
      const response = await listIcons();
      return response.result;
    },
    select: (result): Array<Icon> => result.icons ?? [],
    staleTime: 5 * 60 * 1000,
  });
}
